<app-ds-autocomplete
	[label]="label"
	[placeholder]="placeholder"
	[hint]="hint"
	[required]="required"
	[disabled]="disabled"
	[options]="empleados"
	[displayWith]="displayEmpleado"
	[filterWith]="filterEmpleado"
	[optionTpl]="empOptTpl"
	[value]="selectedEmpleado"
	(valueChange)="onValueChange($event)"
	(touched)="onControlTouched()"
></app-ds-autocomplete>

<ng-template #empOptTpl let-empleado>
	<div class="emp-opt">
		<span class="emp-av">{{ initials(empleado) }}</span>
		<span class="emp-tx">
			<span class="emp-name">{{ displayEmpleado(empleado) }}</span>
			<span class="emp-sub" *ngIf="empleado.email || empleado.funcionAgregada">
				{{ empleado.email || empleado.funcionAgregada }}
			</span>
		</span>
	</div>
</ng-template>
